import { render } from "./YourContribution.vue?vue&type=template&id=968d654a&scoped=true&lang=html"
import script from "./YourContribution.vue?vue&type=script&lang=js"
export * from "./YourContribution.vue?vue&type=script&lang=js"

import "./YourContribution.vue?vue&type=style&index=0&id=968d654a&lang=scss&scoped=true"

import exportComponent from "/Applications/MAMP/htdocs/frauenkirche/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-968d654a"]])

export default __exports__